var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn mr-10 mt-10",
      class: { "btn-primary": _vm.isSelected, "btn-inactive": !_vm.isSelected },
      attrs: { disabled: _vm.loading },
      on: {
        click: function($event) {
          return _vm.$emit("domain-option-clicked", _vm.domain.id)
        }
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.domain.name) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e54c342", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e54c342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/evaluations/components/DomainSelectOption.vue
// module id = ptPc
// module chunks = 1